import { Array, Boolean, Null, Number, Record, Static, String } from "runtypes";

export const ResponseSummaryResponseRuntype = Record({
  coachId: Number,
  parentSummary: String.Or(Null),
  studentSummary: String,
  studentComments: Array(String),
  studentCommentsEdited: Boolean,
  surveyQuestionId: Number,
});

export interface IResponseSummaryResponse
  extends Static<typeof ResponseSummaryResponseRuntype> {}



// WEBPACK FOOTER //
// ./src/api/types/IResponseSummaryResponse.ts